import { Component, forwardRef, Inject, Input } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { EventDetailsPageDialogComponent } from "../../dashboard-area/event-details/event-details-page-dialog.component";
import { Alert } from "../../model";

@Component({
    selector: 'event-details-box',
    template: require('./event-details-box.component.html'),
    styles: [require('./event-details-box.component.css')]
})
export class EventDetailsBoxComponent {

    @Input() event: Alert;

    @Input() isHistorical: boolean;

    @Input() ticketButtonDisabled: boolean;

    constructor(
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog
    ) { }

    openDetailsDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '25%';
        dialogConfig.data = { id: this.event.id, isHistorical: this.isHistorical, ticketButtonDisabled: this.ticketButtonDisabled };
        this.dialog.open(EventDetailsPageDialogComponent, dialogConfig);
    }
}